import { AuthenticatedUserAccount } from 'eop-ui-core/types/AuthenticatedUserAccount'
import { Module } from 'vuex'
import { RootState } from '@/store'

export interface AccountState {
  userAccount?: AuthenticatedUserAccount
  superuser: boolean
  master: boolean
}

const accounts: Module<AccountState, RootState> = {
  namespaced: true,
  state: {
    userAccount: JSON.parse(localStorage.getItem('account') || 'null') || undefined,
    superuser: false,
    master: false,
  },
  getters: {
    getUserAccount(state) {
      return state.userAccount
    },
    isSuperuser(state) {
      return state.superuser
    },
    isMaster(state) {
      return state.master
    },
  },
  mutations: {
    setUserAccount(state, userAccount) {
      userAccount ? localStorage.setItem('account', JSON.stringify(userAccount)) : localStorage.removeItem('account')
      state.userAccount = userAccount
    },
    setSuperuser(state, superuser) {
      state.superuser = superuser
    },
    setMaster(state, master) {
      state.master = master
    },
  },
  actions: {
    updateUserAccount({ getters, commit }) {
      const stored = JSON.parse(localStorage.getItem('account') || 'null')
      if (getters['getUserAccount'] !== stored) {
        commit('setUserAccount', stored || undefined)
      }
    },
    setUserAccount({ commit }, userAccount) {
      commit('setUserAccount', userAccount)
    },
    setSuperuser({ commit }, superuser) {
      commit('setSuperuser', superuser)
    },
    setMaster({ commit }, master) {
      commit('setMaster', master)
    },
  },
}

export default accounts
